module.exports = __webpack_public_path__ + "static/media/wave-9.01ed49d7.svg";